import React from "react";
import ReactDOM from "react-dom/client";
import "tippy.js/dist/tippy.css";
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
